import { call, put, takeLatest } from 'typed-redux-saga'
import { SberOprosNs, sberOprosSlice, errorHandler } from 'Modules'
import { sberOprosApi } from 'Modules/SberOpros'
import { authApi, authSlice } from 'Pages/auth'

function* setFeedbackSaga(action: SberOprosNs.setFeedback) {
	try {
		const { id, result } = action.payload
		yield* call(sberOprosApi.sendFeedback, result)
		const user = yield* call(authApi.getUser, id)
		yield* put(authSlice.actions.setUser(user))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* sberOprosSaga() {
	yield* takeLatest(sberOprosSlice.actions.setFeedback.type, setFeedbackSaga)
}
